import { AccessManagementRoutes } from '@linkdev/access-manage-library';


export const DimUrl = [
    `${AccessManagementRoutes.profileRoute}/${AccessManagementRoutes.addTeamRoute}`,
    `${AccessManagementRoutes.profileRoute}/${AccessManagementRoutes.editTeamRoute}`,
    `${AccessManagementRoutes.profileRoute}/${AccessManagementRoutes.fillProfileLinkRoute}`];